import SelectWeex from "../elements/SelectWeex";
import mailIcon from "../../img/mail.png";
import phoneIcon from "../../img/phone.png";
import {useContext, useEffect, useState} from "react";
import {postBackendAsync} from "../api/APIfunctions.tsx";
import {useNavigate} from "react-router-dom";
import {getRemainingTickets, roles} from "../ToDos";
import {TabMenu} from "../TabMenu.tsx";
import {Modal} from "../Modal.tsx";
import NumberInputWeex from "../elements/NumberInputWeex";
import {loadFromStorage} from "../api/LocalStorage.tsx";
import {APIContext} from "../Globals.tsx";

export default function PersonView({user, setEditing, updateEgo, setContractType, contractType, contracts, setUser, handleChange}){

    const [modal, setModal] = useState(false);
    const [resetModal, setResetModal] = useState(false);
    const [extraTickets, setExtraTickets] = useState(0);
    const [BackendUrl, setBackendUrl] = useState("");
    const navigate = useNavigate();
    const {enablePersonForPayment}  = useContext(APIContext)

    useEffect(() => {
        setBackendUrl(localStorage.getItem("backendUrl"))
    }, []);

    useEffect(() => {
        if(!modal){
            loadFromStorage("tmpUser").then((r)=>r&&setUser(r))
            setExtraTickets(0)
        }
    }, [modal]);

    return (
        <div className={"grid gridtwo_person"}>
            {resetModal &&
                <Modal actionP={() => {
                    postBackendAsync("/login/forgotPassword", {email: user.email}, () => {}, true).then(()=>window.location.reload())
                }} actionS={() => setResetModal(false)} buttonP={"Senden"} buttonS={"Abbrechen"} valid={true}>
                    <h2>E-Mail zum Zurücksetzen des Passwortes an das Mitglied senden?</h2>
                </Modal>}
            {modal &&
                <Modal actionP={() => {
                    updateEgo();
                }} actionS={() => setModal(false)} buttonP={"Speichern"} buttonS={"Abbrechen"} valid={true}>
                    <h1>Vertrag von {user.firstname} ändern</h1>
                    <div className={"flex-row"}>
                        <label style={{alignContent: "center"}}> Vertrag: </label>
                        <SelectWeex options={contracts}
                                    onChange={(e)=> {
                                        setContractType(e);
                                        setUser(old=> {
                                            old.ticketsMax = (e?.tickets??0)+parseInt(extraTickets);
                                            return old;
                                        })
                                    }}
                                    placeholder={"3 pro Woche"}
                                    isMulti={false}
                                    value={contractType}
                                    style={{width: 210, display: "inline-block"}}
                        />
                    </div>
                    <div className={"flex-row"}>
                        <label style={{alignContent: "center"}}> Vertragsbeginn: </label>
                        <input type="date" name="contractStart"
                               onChange={e => setUser(old => {
                                   return {
                                       ...user,
                                       "contract": {
                                           repeat: old.contract?.repeat,
                                           startDate: e.target.value,
                                           endDate: old.contract?.endDate
                                       }
                                   };
                               })}
                               value={user.contract?.startDate} placeholder={"YYYY-MM-DD"}/>
                    </div>
                    <div className={"flex-row"}>
                        <label style={{alignContent: "center"}}> Vertragsende: </label>
                        <input type="date" name="contractEnd"
                               onChange={e => setUser(old => {
                                   return {
                                       ...user, "contract":
                                           {
                                               repeat: old.contract?.repeat,
                                               startDate: old.contract?.startDate,
                                               endDate: e.target.value
                                           }
                                   };
                               })}
                               value={user.contract?.endDate} placeholder={"YYYY-MM-DD"}/>
                    </div>
                    <div>Tickets: {getRemainingTickets(user, new Date())}/{user.ticketsMax}</div>
                    {user.contract?.repeat.includes("block") && <div>
                        <hr style={{width: "100%"}}/>
                        <h1>Kontingent erhöhen</h1>
                        <div className={"flex-row"}>
                            <NumberInputWeex onChange={(e) => {
                                setExtraTickets(e);
                                setUser(old => {
                                    old.ticketsMax += parseInt(e - extraTickets);
                                    return old;
                                });
                            }} value={extraTickets} placeholder={"..."}
                                             style={{width: 50}}/>
                            <div style={{alignContent: "center"}}>Einheiten schenken</div>
                        </div>
                    </div>}
                </Modal>
            }
            <div>
                <div className={"user_profilbild"}>
                    <img
                        src={BackendUrl+user.photo}
                        alt={"profileImage"}/>
                </div>
                <h2>{user.firstname} {user.lastname}</h2>
                <p> {user.sex} </p>
                <div>
                    <img className={"icon"} src={mailIcon} alt={"mailIcon"}/>
                    <img className={"icon"} src={phoneIcon} alt={"phoneIcon"}/>
                </div>
                <SelectWeex placeholder={"Mitgliedschaft"} value={roles[user.authLevel + 1]} options={roles}
                            onChange={(c)=>handleChange(c.value)} editable={false} isClearable={false}/>
                {/*<p>{(new Date(user.birthday)).toLocaleDateString('de-DE')}</p>*/}
                <button className={"primarybutton"} style={{marginTop: 10}}
                        onClick={()=>setResetModal(true)}>Passwort
                    zurücksetzen
                </button>
                {!user.stripeId&&<button className={"primarybutton"} style={{marginTop: 10}}
                         onClick={() => enablePersonForPayment(user.id).then((e) => e&&window.location.reload())}
                         disabled={!user.address || !user.address.city || !user.address.zip || !user.address.country || !user.address.street}
                >
                    Für Zahlungen authorisieren
                </button>}
            </div>

            <div>
                <TabMenu tabs={user.authLevel < 0?["Informationen"]:["Informationen", "Mitgliedschaft", "Rechnungen", "Notizen"]} actionPText={"Bearbeiten"}
                         onChange={(tab, context) => {
                             switch(tab){
                                 case 0:
                                     context.setActionPText("Bearbeiten");
                                     context.setActionP(() => {
                                         navigate(window.location.pathname + "?edit=true");
                                         setEditing(true);
                                     });
                                     break;
                                 case 1:
                                     context.setActionPText("Vertag ändern");
                                     context.setActionP(() => setModal(true));
                                     break;
                                 default:
                                     context.setActionP(null);
                             }
                         }}>
                    <div id={"Information"}>
                        <table>
                            <tbody>
                            <tr>
                                <td>E-Mail</td>
                                <td>{user.email}</td>
                            </tr>
                            <tr>
                                <td>Verifiziert</td>
                                <td>
                                    {user.verified === true ? "Ja" : "Nein"}
                                </td>
                            </tr>
                            <tr>
                                <td>Telefonnummer</td>
                                <td>{user.phone}</td>
                            </tr>
                            <tr>
                                <td>Geburtstag</td>
                                <td>{new Date(user.birthday).toLocaleDateString('de-DE')}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div id={"Mitgliedschaft"}>
                        <table>
                            <tbody>
                            <tr>
                                <td>Tickets</td>
                                <td>
                                  {user.tickets === getRemainingTickets(user, new Date()) ? user.tickets : "not sure"}/{user.ticketsMax}
                                </td>
                            </tr>
                            <tr>
                                <td>Gültig von - bis</td>
                                <td>
                                    {new Date(user.contract?.startDate).toLocaleDateString('de-DE')} - {new Date(user.contract?.endDate).toLocaleDateString('de-DE')}
                                </td>
                            </tr>
                            <tr>
                                <td>Kurse:</td>
                                <td style={{whiteSpace: "break-spaces"}}>{user.courses.map(course => course.type + " - " + new Date(course.startDate).toLocaleDateString('de-DE') + "\n")}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div id={"Rechnungen"}>
                        <h3>Rechnungen</h3>
                        {user.address&&<table>
                            <tbody>
                            <tr>
                                <td>Zahlungs-ID:</td>
                                <td>
                                    {user.stripeId}
                                </td>
                            </tr>
                            <tr>
                                <td>Rechnungadresse</td>
                                <td>
                                    <div>
                                    {user.address.street??"??"}, {user.address.zip??"??"}, {user.address.city??"??"}, {user.address.country??"??"}
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>}
                    </div>
                    <div id={"Notizen"}>
                        <h3>Notizen</h3>
                    </div>
                </TabMenu>

            </div>
        </div>
    );
}


